import React from 'react'

export const NetworkWarning = () => {
  return (
    <div className="card">
      <p className="text-error is-vertical-align">
        Note: you are currently connected to the Carthagenet network.
      </p>
    </div>
  )
}
